import { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { clsx } from 'clsx'
import { MobileDrawer } from './MobileDrawer'

const BOTTOM_TABS = [
  {
    to: '/terminal',
    label: 'Terminal',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-5 h-5">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M8 9l3 3-3 3M13 15h3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    to: '/screener',
    label: 'Screener',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-5 h-5">
        <path d="M3 6h18M7 12h10M10 18h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    to: '/portfolio',
    label: 'Portfolio',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-5 h-5">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" strokeLinecap="round" />
        <line x1="12" y1="12" x2="12" y2="16" strokeLinecap="round" />
        <line x1="10" y1="14" x2="14" y2="14" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    to: '/research',
    label: 'Research',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-5 h-5">
        <path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
]

// Routes that belong to the "More" drawer section
const MORE_PATHS = [
  '/options', '/flows', '/risk', '/macro', '/sectors', '/social', '/events',
  '/crypto', '/multi-chart', '/bot', '/watchlist', '/messages',
  '/calculators', '/seasonality', '/settings', '/admin', '/guide',
]

export function MobileBottomNav() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const location = useLocation()
  const isMoreActive = MORE_PATHS.some((p) => location.pathname.startsWith(p))

  return (
    <>
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      <nav
        className="fixed bottom-0 left-0 right-0 z-40 flex items-center bg-bb-surface border-t border-bb-border"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        aria-label="Mobile navigation"
      >
        {BOTTOM_TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              clsx(
                'flex-1 flex flex-col items-center justify-center gap-0.5 py-2 transition-colors',
                isActive ? 'text-bb-orange' : 'text-bb-subtle'
              )
            }
          >
            {({ isActive }) => (
              <>
                {tab.icon(isActive)}
                <span className="text-2xs font-medium">{tab.label}</span>
              </>
            )}
          </NavLink>
        ))}

        {/* More button */}
        <button
          onClick={() => setDrawerOpen(true)}
          className={clsx(
            'flex-1 flex flex-col items-center justify-center gap-0.5 py-2 transition-colors',
            isMoreActive ? 'text-bb-orange' : 'text-bb-subtle'
          )}
          aria-label="More pages"
        >
          <svg viewBox="0 0 24 24" fill="none" strokeWidth={isMoreActive ? 2 : 1.5} stroke="currentColor" className="w-5 h-5">
            <circle cx="4" cy="12" r="1.5" fill="currentColor" stroke="none" />
            <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
            <circle cx="20" cy="12" r="1.5" fill="currentColor" stroke="none" />
          </svg>
          <span className="text-2xs font-medium">More</span>
        </button>
      </nav>
    </>
  )
}
